var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTable',{attrs:{"cols":_vm.cols,"data":_vm.items},on:{"selectOne":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }